import {Injectable} from '@angular/core';
import {LoginHelper} from '../helpers';

import {AuthenticationService} from './index';
import {Load} from "../_decorators/loading.decorator";
import {AuditItem} from "../_models/auditItem";
import {Audit} from "../_models/audit";
import {HttpClient} from "@angular/common/http";
import {IndexConfigService} from "./index.config.service";

@Injectable()
export class AuditService {
  constructor(public http: HttpClient,
              public authenticationService: AuthenticationService,
              public config: IndexConfigService) {
  }

  getAllAudits() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/audit' + '');
  }

  getAuditTemplates() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/audit/template' + '');
  }

  @Load()
  addAudit(templateId: number, audit: Audit) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.put(this.config.api + '/api/audit/' + templateId + '', audit);
  }

  @Load()
  updateAudit(audit: Audit) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/audit' + '', audit);
  }

  @Load()
  deleteAudit(id) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.delete(this.config.api + '/api/audit/' + id + '');
  }

  getAuditItems(id) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/audititem/' + id + '');
  }

  @Load()
  addAuditItem(audititem: AuditItem) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.put(this.config.api + '/api/audititem', audititem);
  }

  @Load()
  updateAuditItem(audititem:AuditItem) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/audititem', audititem);
  }

  @Load()
  deleteAuditItem(id) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.delete(this.config.api + '/api/audititem/' + id + '');
  }

  @Load()
  uploadAttachment(auditItemId: number, entity){

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(entity.name, entity, entity.name);

    return this.http
      .post<any>(this.config.api + '/api/audit/attachment?auditItemId=' + auditItemId, formData)
      ;

  }

  @Load()
  setAuditItemOrder(order: number[]) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/audititem/order', order);
  }

  @Load()
  deleteAttachment(id) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.delete(this.config.api + '/api/audititem/attachment/' + id + '');
  }

}
